import { Component, ElementRef, HostListener, effect } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
/*Servicios*/
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification/notification.component';
import { Router } from '@angular/router';
import { ModalSalirComponent } from '../modal-salir/modal-salir.component';
import { MicarteraService } from '../../services/micartera.service';
import { CotizadoresService } from '../../services/cotizadores.service';
import { ModalLicenciaComponent } from './helpers/modal-licencia.component';
import { GoogleAnalyticsService } from '../../services/google-analytics/google-analytics.service';
@Component({
  selector: 'app-profile-menu',
  standalone: true,
  imports: [
    MatDialogModule,
    CommonModule,
    NotificationComponent,
    ModalSalirComponent,
    ModalLicenciaComponent,
  ],
  templateUrl: './profile-menu.component.html',
  styleUrl: './profile-menu.component.css',
})
export class ProfileMenuComponent {
  username: string | null = null; // Propiedad para almacenar el username
  lastAccess: string | null = null; // Propiedad para almacenar el lastacess
  searchResults: string[] = [];
  mostrarModalSalir: boolean = false;
  showLicenciaModal = false;
  fechaExpiracion = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private micarteraService: MicarteraService,
    private elementRef: ElementRef,
    public cotizadoresService: CotizadoresService,
    private gAnalytics:GoogleAnalyticsService
  ) {
    // Inyección correcta del servicio
    this.username = this.authService.getUsername();
    this.lastAccess = this.authService.getLastacess(); // Obtén el username y lastacess al instanciar el componente

    
    // Effect para ejecutar verificar licencia cada vez que el signal producerLicence cambie.
    effect(() => {
      this.cotizadoresService.producerLicence();
      this.verificarLicencia();
    });
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  /*Emulando notificaciones */
  notifications = [
    'Nueva actualización disponible.',
    'Tienes un mensaje nuevo.',
    '¡Felicidades! Has ganado un premio.',
    'Recuerda verificar tu correo electrónico.',
    'Se ha actualizado tu perfil correctamente.',
    'Tienes una reunión programada para mañana.',
    'Tu contraseña ha sido cambiada exitosamente.',
    'Hay un nuevo comentario en tu publicación.',
    'Se ha agregado un nuevo amigo.',
    'Tu solicitud de amistad ha sido aceptada.',
    'Recibiste un nuevo "me gusta" en tu foto.',
    'Tienes un recordatorio para hoy.',
    'Se ha publicado un nuevo artículo en tu área de interés.',
    'Tu cuenta ha sido verificada.',
    'Tienes un nuevo mensaje en el chat.',
    'Se ha completado tu pedido.',
    'Hay una nueva actualización de la aplicación.',
    'Recibiste un nuevo desafío.',
    'Tu suscripción se ha renovado.',
    'Tienes un nuevo seguidor.',
    'Se ha activado la autenticación de dos factores.',
  ];

  /*Dropdown*/
  isOpen = false;
  selectedOption = '';
  options = [
    {
      name: 'Ver perfil',
      icon: './assets/user-main.svg',
    },
    {
      name: 'Cambiar contraseña',
      icon: './assets/password.svg',
    },
    {
      name: 'Cerrar sesión',
      icon: './assets/salir.svg',
    },
  ];

  toggleDropdown(event: Event): void {
    event.stopPropagation(); // Evita que el clic en el botón llegue al documento
    this.isOpen = !this.isOpen;
  }

  selectOption(option: string): void {
    this.selectedOption = option;

    this.isOpen = false;

    if (option === 'Ver perfil') {
      this.router.navigate(['/inicio/perfil']);
    }
    
    if (option === 'Cambiar contraseña') {
      this.router.navigate(['/inicio/cambiar-contrasena']);
      this.selectedOption = 'Mi perfil';
    }
    
    if (option === 'Cerrar sesión') {
      this.mostrarModalSalir = true;
    }

  }

  onConfirmarSalir(): void {
    this.authService.signOut();
    this.micarteraService.clearCache();
    this.mostrarModalSalir = false;
    this.gAnalytics.trackEvent('cerrar_sesion',{
      action:'Cerrar sesión'
    })
  }

  onCancelarSalir(): void {
    this.mostrarModalSalir = false;
    this.selectedOption = 'Mi perfil';
  }

  // Esta función se ejecuta cuando la campana es clickeada
  onBellClick() {
    console.log('Campana de notificaciones clickeada');
  }

  // Licencia
  getLicence(): string {
    const licence = this.cotizadoresService.getProducerLicence();
    if (licence.expiredLicence === 'NO') {
      return `Licencia Activa - Válida hasta: ${licence.expirationDate}`;
    } else {
      return 'Licencia expirada';
    }
  }

  /**
   * Devuelve el estado operativo del productor (independiente de la licencia)
   * @returns Texto del backend o cadena vacía si aún no hay datos
   */
  getProducerStatus(): string {
    return `Estado: ${this.cotizadoresService.getProducerStatus()}`;
  }

  /**
   * Muestra un modal de advertencia si se debe alertar al usuario sobre el próximo vencimiento de su licencia,
   * según la señal 'showExpirationWarning' proporcionada por el backend.
   *
   * Este método:
   * 1. Obtiene la información actual de la licencia desde el servicio de cotizadores.
   * 2. Si la propiedad 'showExpirationWarning' está activa, muestra el modal con la fecha de expiración.
   */
  verificarLicencia() {
    const licencia = this.cotizadoresService.getProducerLicence();
    if (licencia.showExpirationWarning === true) {
      this.fechaExpiracion = licencia.expirationDate;
      this.showLicenciaModal = true;
    }
  }

  onCloseLicenciaModal(): void {
    this.showLicenciaModal = false;
  }
}
